import React, { useState } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Password } from "primereact/password";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import ShowConfirm from "../shared/ShowConfirm";

export default function ResetPassword (props) {
    const [panelRequestVisible, setPanelRequestVisible] = useState(true);
    const [panelSavePasswoerdVisible, setPanelSavePasswoerdVisible] = useState(false);
    const [nationalId, setNationalId] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [confirmPassword, setConfirmPassword] = useState("");
    const [resetCode, setResetCode] = useState("");
    const [redirectUrl, setRedirectUrl] = useState("");
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [saving, setSaving] = useState(false);
    const [readyToLoginVisible, setReadyToLoginVisible] = useState(false);

    const onInputChange = function(e, name){
        var val = '';
        val = (e.target && e.target.value) || '';
        if(name === "nationalId") setNationalId(val);
        else if(name === "newPassword") setNewPassword(val);
        else if(name === "confirmPassword") setConfirmPassword(val);
        else if(name === "resetCode") setResetCode(val);
    }
    const checkDataEntry = function(){
        if(nationalId.trim().length == 0){
            setErrorMessage("کد ملی را وارد کنید");
            setErorVisible(true);
            return false;
        }
        return true;
    }
    const requestResetCode = function(){
        if(!checkDataEntry()) return;
        setSaving(true);
        var params = {nationalId:nationalId};
        var url = config.Server+`/user/request-reset-password`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                if(response.state === "ok"){
                    response = response.data;
                    console.log("response is>", response);
                    
                    setSaving(false);
                    setPanelRequestVisible(false);
                    setPanelSavePasswoerdVisible(true);
                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                    setSaving(false);
                }
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
                setSaving(false);
            });
    }
    const checkDataEntry2 = function(){
        if(resetCode.trim().length != 4){
            setErrorMessage("کد پیامک شده را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(newPassword === ""){
            setErrorMessage("کلمه عبور جدید را مشخص کنید");
            setErorVisible(true);
            return false;
        }
        if(confirmPassword === ""){
            setErrorMessage("تکرار کلمه عبور را وارد کنید");
            setErorVisible(true);
            return false;
        }
        if(confirmPassword != newPassword){
            setErrorMessage("کلمه عبور با تکرار آن یکسان نمی باشد");
            setErorVisible(true);
            return false;
        }
        return true;
    }
    const saveNewPassword = function(){
        if(!checkDataEntry2()) return;
        setSaving(true);
        var params = {nationalId:nationalId, smsCode:resetCode, newPassword:newPassword};
        var url = config.Server+`/user/set-new-password`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
            .post(url, params )
            .then(res => {
                var response = res.data;
                if(response.state === "ok"){
                    response = response.data;
                    console.log("response is>", response);
                    
                    setSaving(false);
                    setPanelRequestVisible(false);
                    setPanelSavePasswoerdVisible(false);
                    setReadyToLoginVisible(true);
                }
                else{
                    setErrorMessage(response.message);
                    setErorVisible(true);
                    setSaving(false);
                }
            })
            .catch(error => {
                setErrorMessage(error.code + "," + error.message);
                setErorVisible(true);
                setSaving(false);
            });
    }
    return(
        <>
        {
            (redirectUrl != "")
            ?
            <Navigate to={redirectUrl} replace={false}  />
            :
            <></>
        }
        {
            false?
            <>
            {
            (panelRequestVisible)?    
            <div style={{width:"100%", boxSizing:"border-box", padding:"20px"}}>
                <table style={{width:"100%", minWidth:"250px", maxWidth:"350px", marginLeft:"auto", marginRight:"auto"}}>
                    <tbody>
                        <tr>
                            <td style={{width:"100%", textAlign:"center"}}><span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-key"></span></td>
                        </tr>
                        <tr>
                            <td style={{fontSize:"1.5em", textAlign:"center"}}>درخواست کلمه عبور جدید</td>
                        </tr>
                        <tr><td>&nbsp;</td></tr>
                        <tr>
                            <td style={{fontSize:"1.5em", textAlign:"center", direction:"ltr"}}>
                                <FloatLabel>
                                    <InputText value={nationalId} onChange={(e)=>{onInputChange(e, "nationalId")}} id="nationalId" keyfilter="int" maxLength={12} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                                    <label htmlFor="username">کد ملی</label>
                                </FloatLabel>
                                
                            </td>
                        </tr>
                        <tr><td>&nbsp;</td></tr>
                        <tr>
                            <td style={{textAlign:"right"}}>
                            <React.Fragment>
                                <div className="card flex justify-content-center" style={{ direction: "ltr" }}>
                                    <Button label="درخواست کد بازسازی" icon="pi pi-check" onClick={()=>requestResetCode()} loading={saving} severity="success" iconPos="right" />
                                </div>
                            </React.Fragment>

                            </td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <div style={{textAlign:"center", direction:"rtl"}}>
                    <Link to="/login" style={{textDecoration:"none", color:"#a0a0a0"}}>کلمه عبور دارم</Link>                
                </div>
            </div>
            :
            (panelSavePasswoerdVisible)?
            <div style={{width:"100%", boxSizing:"border-box", padding:"20px"}}>
                <table style={{width:"100%", minWidth:"250px", maxWidth:"350px", marginLeft:"auto", marginRight:"auto"}}>
                    <tbody>
                        <tr>
                            <td style={{width:"100%", textAlign:"center"}}><span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-key"></span></td>
                        </tr>
                        <tr>
                            <td style={{fontSize:"1.5em", textAlign:"center"}}>ثبت کلمه عبور جدید</td>
                        </tr>
                        <tr><td>&nbsp;</td></tr>
                        <tr>
                            <td style={{fontSize:"1.5em", textAlign:"center", direction:"ltr"}}>
                                <FloatLabel>
                                    <InputText value={resetCode} onChange={(e)=>{onInputChange(e, "resetCode")}} id="resetCode" keyfilter="int" maxLength={4} className="p-inputtext-lg" style={{width:"100%", textAlign:"center"}} />
                                    <label htmlFor="username">کد پیامک شده</label>
                                </FloatLabel>
                                
                            </td>
                        </tr>
                        <tr><td>&nbsp;</td></tr>
                        <tr>
                            <td style={{fontSize:"1.5em", textAlign:"center", direction:"ltr"}}>
                                <FloatLabel>
                                    <Password value={newPassword} onChange={(e)=>{onInputChange(e, "newPassword")}} id="newPassword" maxLength={30} className="p-inputtext-lg" pt={{
                                                    iconField: {
                                                        root: {
                                                        style: { width: "100%" },
                                                        },
                                                    },
                                                    input: {
                                                        style: { width: "100%", textAlign:"center" },
                                                    },
                                                    root: {
                                                        style: { width: "100%" },
                                                    },
                                                    }} toggleMask feedback={false} />
                                    <label htmlFor="password">کلمه عبور</label>
                                </FloatLabel>
                                
                            </td>
                        </tr>
                        <tr><td>&nbsp;</td></tr>
                        <tr>
                            <td style={{fontSize:"1.5em", textAlign:"center", direction:"ltr"}}>
                                <FloatLabel>
                                    <Password value={confirmPassword} onChange={(e)=>{onInputChange(e, "confirmPassword")}} id="confirmPassword" maxLength={30} className="p-inputtext-lg" pt={{
                                                    iconField: {
                                                        root: {
                                                        style: { width: "100%" },
                                                        },
                                                    },
                                                    input: {
                                                        style: { width: "100%", textAlign:"center" },
                                                    },
                                                    root: {
                                                        style: { width: "100%" },
                                                    },
                                                    }} toggleMask feedback={false} />
                                    <label htmlFor="password">تکرار کلمه عبور</label>
                                </FloatLabel>
                                
                            </td>
                        </tr>
                        <tr><td>&nbsp;</td></tr>
                        <tr>
                            <td style={{textAlign:"right"}}>
                            <React.Fragment>
                                <div className="card flex justify-content-center" style={{ direction: "ltr" }}>
                                    <Button label="ثبت کلمه عبور" icon="pi pi-check" onClick={()=>saveNewPassword()} loading={saving} severity="success" iconPos="right" />
                                </div>
                            </React.Fragment>

                            </td>
                        </tr>
                    </tbody>
                </table>
                <br />
                <div style={{textAlign:"center", direction:"rtl"}}>
                    <Link to="/login" style={{textDecoration:"none", color:"#a0a0a0"}}>کلمه عبور دارم</Link>                
                </div>
            </div>
            :

            <></>
            }
            {
                readyToLoginVisible?
                <div style={{width:"100%", boxSizing:"border-box", padding:"20px"}}>
                    <table style={{width:"100%", minWidth:"250px", maxWidth:"350px", marginLeft:"auto", marginRight:"auto"}}>
                        <tbody>
                            <tr>
                                <td style={{width:"100%", textAlign:"center"}}><span style={{fontSize:"4em", textAlign:"center"}} className="pi pi-key"></span></td>
                            </tr>
                            <tr>
                                <td style={{fontSize:"1.5em", textAlign:"center"}}>با موفقيت ثبت گردید</td>
                            </tr>
                            <tr><td>&nbsp;</td></tr>
                            <tr><td>&nbsp;</td></tr>
                            <tr>
                                <td style={{textAlign:"right"}}>
                                <React.Fragment>
                                    <div className="card flex justify-content-center" style={{ direction: "ltr" }}>
                                        <Button label="ورود به سامانه" icon="pi pi-check" onClick={()=>setRedirectUrl("/login")} loading={saving} severity="success" iconPos="right" />
                                    </div>
                                </React.Fragment>

                                </td>
                            </tr>
                        </tbody>
                    </table>
                    <br />
                </div>
                :
                <></>
            }
            </>
            :
            <>
                <div style={{padding:"10px", margin:"20px", border:"1px solid #b0b0b0", borderRadius:"10px"}}>
                    <label>
                        اگر دانش آموز، ولی دانش آموز یا معلم هستید جهت باسازی کلمه عبور با مدیر مدرسه یا معاونین مدرسه هماهنگ نمائید.
                        <br/>
                        مسئولین مدرسه می توانند رمز شما را بازسازی نمایند
                    </label>
                    <hr/>
                    <label>
                        اگر مدیر مدرسه یا نماینده فروش هستید با پشتیبانی سامانه کلاسیکو 7 تماس بگیرید
                    </label>
                    <hr/>
                    <div>
                        <React.Fragment>
                            <div className="card flex justify-content-center" style={{ direction: "ltr" }}>
                                <Button label="ورود به سامانه" icon="pi pi-check" onClick={()=>setRedirectUrl("/login")} loading={saving} severity="success" iconPos="right" />
                            </div>
                        </React.Fragment>

                    </div>
                </div>
            </>
        }
        <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
        
        </>
    );
}
